import React from "react"
import { Button, Title } from "dash-styled"
import { routePaths } from "../../../../../../../../Routes"

interface BaselineBannerProps {
    onAdd: () => void
}

export function BaselineBanner({ onAdd }: BaselineBannerProps) {
    return (
        <div className="flex flex-col lg:flex-row p-4 bg-rhino-250 rounded items-start lg:items-center">
            <div className="flex-grow">
                <Title
                    component="h3"
                    variant="heading4"
                    className="text-rhino-750"
                    noMargin={true}
                >
                    Add ground truth to improve quality and lower cost
                </Title>
                <p className="text-rhino-600 my-1 text-sm">
                    Ground truth is input data together with the correct output.
                    You can upload it directly, or convert processed data points
                    to ground truth when you review them.{" "}
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-pink-500"
                        href={routePaths.docs("ground-truth")}
                    >
                        Learn more
                    </a>
                </p>
            </div>
            <Button
                onClick={onAdd}
                variant="contained"
                color="darkviolet"
                className="flex-grow-0 flex-shrink-0 w-auto mt-2 ml-0 lg:mt-0 lg:ml-5 px-8"
                testId="upload-ground-truth-button"
            >
                Upload ground truth
            </Button>
        </div>
    )
}
